import React, { useState } from "react";
import "./Roadmap.scss";

import RoadmapIcon1 from "../../assets/images/phase-1.png";
import RoadmapIcon2 from "../../assets/images/phase-2.png";
import RoadmapIcon3 from "../../assets/images/phase-3.png";
import RoadmapIcon4 from "../../assets/images/phase-4.png";

import BubbleImg1 from "../../assets/images/bubble-1.png";
import BubbleImg2 from "../../assets/images/bubble-2.png";

export default function Roadmap() {
	const [hoveredCard, setHoveredCard] = useState(null);

	const roadmapData = [
		{
			icon: RoadmapIcon1,
			phase: "Phase 1",
			title: "Lay the Foundation",
			description:
				"AurAI builds the Auracle platform with AI models & predictive algorithms for DeFi. It fosters community growth through marketing, education & engagement. Partnerships with DeFi protocols, exchanges drive visibility & ecosystem expansion. Ensuring security with smart contracts & Aur Token launch.",
			link: "https://aur-ai.gitbook.io/aurai/roadmap/phase-one-lay-the-foundation",
		},
		{
			icon: RoadmapIcon2,
			phase: "Phase 2",
			title: "Expanding Ecosystem",
			description:
				"AurAI will release Auracle's beta to test performance & gather feedback for scalability. AurTrader's vision will be defined with a prototype & backend setup. Community growth efforts will focus on partnerships & marketing. Continuous improvements will enhance features, security & performance.",
			link: "https://aur-ai.gitbook.io/aurai/roadmap/phase-two-expanding-ecosystem",
		},
		{
			icon: RoadmapIcon3,
			phase: "Phase 3",
			title: "Scaling and Optimization",
			description:
				"AurAI will launch AurTrader with advanced tools and real-time insights. The team will grow by recruiting contributors & advisors to support scaling. Global community expansion will include localized marketing, multilingual resources & a governance model for $AUR Token holders.",
			link: "https://aur-ai.gitbook.io/aurai/roadmap/phase-three-scaling-and-optimization",
		},
		{
			icon: RoadmapIcon4,
			phase: "Phase 4",
			title: "Deliver and Expand",
			description:
				"AurAI will enhance and reinforce AI models with advanced algorithms and extensive training for greater accuracy. Marketing & branding efforts will focus on strategic campaigns to increase visibility, attract users and establish AurAI as a leading name in crypto and AI.",
			link: "https://aur-ai.gitbook.io/aurai/roadmap/phase-four-deliver-and-expand",
		},
	];

	return (
		<>
			<div className="roadmap" id="roadmap">
				<div className="decoration roadmap-light-1"></div>
				<div
					className="decoration roadmap-bubble-1"
					data-aos="fade-right"
				>
					<img
						className="shake-slow-4"
						src={BubbleImg1}
						alt="Bubble"
					/>
				</div>
				<div
					className="decoration roadmap-bubble-2"
					data-aos="fade-left"
				>
					<img
						className="shake-slow-5"
						src={BubbleImg2}
						alt="Bubble"
					/>
				</div>

				<div className="roadmap-content-wrapper content-wrapper-lg">
					<h3 className="roadmap-small-title" data-aos="fade-up">
						Path To Achieving Goals
					</h3>
					<h2
						className="roadmap-title"
						data-aos="fade-up"
						data-aos-delay="50"
					>
						RoadMap
					</h2>
					<p
						className="roadmap-desc"
						data-aos="fade-up"
						data-aos-delay="100"
					>
						Join us on our journey as we continue to innovate and
						expand our AI capabilities, with upcoming features and
						enhancements aimed at enriching your experience.
					</p>

					<div className="roadmap-cards">
						{roadmapData.map((card, index) => (
							<div
								key={index}
								className={`roadmap-card-wrapper ${
									hoveredCard === index ? "open" : ""
								} ${
									hoveredCard !== null &&
									hoveredCard !== index
										? "collapse"
										: ""
								}`}
								onMouseEnter={() => setHoveredCard(index)}
								onMouseLeave={() => setHoveredCard(null)}
							>
								<div className="roadmap-card">
									<div className="gradient-bg"></div>
									<div className="gradient-bg-active"></div>
									<div className="noise-bg"></div>

									<div className="roadmap-card-content">
										<div className="roadmap-card-head">
											<img
												src={card.icon}
												alt="Roadmap Icon"
												className="roadmap-card-icon"
											/>

											<a
												className="learn-more-btn"
												href={card.link}
											>
												Learn More
											</a>
										</div>

										<div className="roadmap-card-small-title">
											{card.phase}
										</div>

										<h4 className="roadmap-card-title">
											{card.title}
										</h4>

										<p className="roadmap-card-desc">
											{card.description}
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
}
